import { Icon } from "@/components/icons/Icon";
import { memo } from "react";

export interface LinkAndCloseComponentProps {
  onClick: () => void;
  contentType: "success" | "error" | "warning" | "info";
  mobileView?: boolean;
  links?: string | string[] | undefined;
}

const LinkAndCloseComponent = ({
  onClick,
  contentType,
  links = undefined,
  mobileView = false,
}: LinkAndCloseComponentProps) => {
  const linksList: string[] | undefined =
    typeof links === "string" ? [links] : links;

  return (
    <>
      {linksList
        ? linksList.map((link: string) => (
            <a
              href={link}
              key={link}
              className={`flex ${mobileView ? "md:hidden" : " max-md:hidden"} message-link`}
            >
              Link
            </a>
          ))
        : null}
      <button
        type="button"
        onClick={onClick}
        className={`${mobileView ? "md:hidden" : "max-md:hidden"} transform translate-y-[4px] h-4 w-4 close-${contentType}`}
      >
        <Icon name="close" className="size-4" />
      </button>
    </>
  );
};

export default memo(LinkAndCloseComponent);
